import axios from 'axios';
import {toast} from "react-toastify";

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
    // OR config.headers.common['Authorization'] = `Bearer ${your_token}`;
    // config.baseURL = `${localStorage.getItem("apiUrl")}/`;

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// function NavigateTo(url) {
//     const navigateTo = useNavigate();
//     navigateTo(url);
// }
//

axios.interceptors.response.use(
  (response) => {
    // //debugger
    if (typeof (response.data) !== "object") {
      // alert(response.data);
      // return
    }
    return response
  },
  (error) => {

    if (error.response) {
      // //debugger
      if (error.response.status === 406) {

        const msg =  " " + error?.response?.data?.message + " "
        toast.error(msg +`خطای شماره 406`);
        return error;

      }
      if (error.response.status === 500) {
        toast.error(`خطای شماره 500 از سرور`);
        return error;

      }
      if (error.response.status === 401 && window.location.pathname !== '/Login') {
        // const NavigateTo =useNavigate();
        sessionStorage.clear()
        localStorage.clear()
        toast.error("لطفا مجددا وارد سامانه شوید");
        // NavigateTo("/Login")
        setTimeout(() => {
          window.location.reload()
        }, 2000);
      }
      if (error.response.status === 401 && window.location.pathname === '/Login') {
        return error;
      }
      if (error.response.status === 403) {
        toast.error("شما مجوز دسترسی به این بخش را ندارید.");
        return error;
      }
    }
    return error;
    // if(error.response.status === 401){
    //     sessionStorage.clear();
    //     useNavigation("/Login")
    //     toast.error("لطفا مجددا وارد سامانه شوید");
    // }
    // error.response.status === 401 &&
    // sessionStorage.clear() &&
    // localStorage.clear() &&
    // NavigateTo("/Login") &&
    // toast.error("لطفا مجددا وارد سامانه شوید");
  }
);

const _axios = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch
}
export default _axios;